import { Injectable } from "@angular/core";
import { API_URL } from "common/constants/sm-constants";
import { UploadStudentDocModel } from "common/models/page-models/applicants/upload-student-doc/upload-grid.model";
import { SmApiService } from "common/services/core-services/sm-api.service";
import { SystemService } from "common/services/core-services/system.service";
import { DataService } from "../../base-data-services/data.service";

@Injectable()
export class UploadHomeDataService extends DataService<UploadStudentDocModel> {
    constructor(protected ss: SystemService,protected http: SmApiService) {
        super(ss,API_URL.uploadHomeVisitScore,http);
    }
 
 
//    override getAPI_URL(): API_URL {
//         return API_URL.getDocumentTypeList;
//       }
   
    createInstance(): UploadStudentDocModel {
        return new UploadStudentDocModel();
    }

    
 
}